export interface FilterableError {
  context?: string | null;
}

export default function filterErrors(): null;
export default function filterErrors<T extends FilterableError>(
  errors: readonly T[] | null | undefined,
  filter?: string | readonly string[] | null,
): T[] | null;
export default function filterErrors(
  errors: object,
  filter?: string | readonly string[] | null,
): FilterableError[] | null;
export default function filterErrors<T extends FilterableError>(
  errors: readonly T[] | object | null = null,
  filter: string | readonly string[] | null = [],
): T[] | null {
  if (!errors) {
    return null;
  }
  if (!Array.isArray(errors)) {
    throw new Error('Non-array provided to filterErrors');
  }
  if (!filter) {
    return [...errors];
  }
  const filtered = errors.filter((error) => error.context != null && filter.indexOf(error.context) > -1);
  if (filtered.length <= 0) {
    return null;
  }
  return filtered;
}
